import React from "react";
import "./servicesection.css";

// const financialPlanningData = {
//   title: ["Financial Planning,", "Performance & Strategic Finance"],

//   accentColor: "#f21b70",

//   subtitle:
//     "Enable forward-looking decision-making through structured financial planning, performance tracking, and capital strategy",

//   relevantFor: [
//     "Corporates & Growth-Stage Businesses",
//     "Family Offices",
//     "Investment Banks & Advisors",
//   ],

//   heroImage:
//     "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",

//   services: [
//     {
//       title: "Budgeting & Planning",
//       description:
//         "Develop integrated budgets with strategic priorities to drive disciplined resource allocation",
//     },
//     {
//       title: "Forecasting & Scenario Modelling",
//       description:
//         "Build dynamic forecasts to support proactive decision-making under changing business conditions",
//     },
//     {
//       title: "Financial & Management Reporting",
//       description:
//         "Deliver timely, decision-grade reports that provide clear visibility into performance",
//     },
//     {
//       title: "Variance Analysis & Performance Insights",
//       description:
//         "Identify key drivers of performance gaps and enable targeted corrective actions",
//     },
//     {
//       title: "KPI Dashboards & Analytics",
//       description:
//         "Design real-time dashboards that translate financial data into actionable insights",
//     },
//     {
//       title: "Strategic Finance & Capital Advisory",
//       description:
//         "Support capital structuring, fundraising, and financial optimisation strategy",
//     },
//     {
//       title: "Board & Stakeholder Reporting",
//       description:
//         "Prepare concise, insight-driven reporting for leadership, investors, and boards",
//     },
//   ],

//   caseStudy: {
//     label: "CASE STUDY",
//     image:
//       "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=900&q=80",
//     title:
//       "Rebuilt board reporting for a $750M investment corporate in under 6 weeks",
//     buttonLabel: "→",
//     href: "#case-study",
//   },
// };

const ServiceSection = ({data}) => {
  return (
    <section
      className="financial-planning"
      style={{ "--accent-color": data.accentColor,"--fp-bg":data.bg }}
    >
      <div className="financial-planning__container container">
        {/* Header */}
        <header className="financial-planning__header">
          <div className="financial-planning__title-wrapper">
            <span className="financial-planning__accent" />

            <h2 className="financial-planning__title">
              {data.title.map((line, index) => (
                <React.Fragment key={line}>
                  {line}
                  {index !== data.title.length - 1 && <br />}
                </React.Fragment>
              ))}
            </h2>
          </div>

          <p className="financial-planning__subtitle">
            {data.subtitle}
          </p>

          <div className="financial-planning__relevant">
            <span>RELEVANT FOR :</span>{" "}
            {data.relevantFor.map((item, index) => (
              <React.Fragment key={item}>
                <strong>{item}</strong>
                {index !== data.relevantFor.length - 1 && " • "}
              </React.Fragment>
            ))}
          </div>
        </header>

        {/* Main content */}
        <div className="financial-planning__content">
          {/* Large image */}
          <div className="financial-planning__visual">
            <img
              src={data.heroImage}
              alt=""
              className="financial-planning__hero-image"
            />
          </div>

          {/* Services1 */}
          <div className="financial-planning__services1">
            {data.services1.map((service, index) => (
              <article
                className={`financial-planning__service financial-planning__service--${index}`}
                key={service.title}
              >
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </article>
            ))}
          </div>


          {/* Services2 */}
          <div className="financial-planning__services1">
            {data.services2.map((service, index) => (
              <article
                className={`financial-planning__service financial-planning__service--${index}`}
                key={service.title}
              >
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </article>
            ))}

            {/* Case study */}
            {/* <a
              href={data.caseStudy.href}
              className="financial-planning__case-study"
            > */}

              {data.caseStudy.href !== "#" ? (
                  <a
                    href={data.caseStudy.href}
                    className="financial-planning__case-study"
                  >
                    <div className="financial-planning__case-image-wrapper">
                      <img
                        src={data.caseStudy.image}
                        alt=""
                        className="financial-planning__case-image"
                      />

                      <span className="financial-planning__case-label">
                        {data.caseStudy.label}
                      </span>
                    </div>

                    <h3 className="financial-planning__case-title">
                      {data.caseStudy.title}
                    </h3>

                    <p className="financial-planning__case-description">
                      {data.caseStudy.description}
                    </p>

                    {/* <span className="financial-planning__case-button" dangerouslySetInnerHTML={{__html:data.caseStudy.buttonLabel}}> */}
                    <span className="financial-planning__case-button">
                      <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.7071 8.07039C18.0976 7.67986 18.0976 7.0467 17.7071 6.65617L11.3431 0.292213C10.9526 -0.0983109 10.3195 -0.0983109 9.92893 0.292213C9.53841 0.682738 9.53841 1.3159 9.92893 1.70643L15.5858 7.36328L9.92893 13.0201C9.53841 13.4107 9.53841 14.0438 9.92893 14.4343C10.3195 14.8249 10.9526 14.8249 11.3431 14.4343L17.7071 8.07039ZM0 7.36328V8.36328H17V7.36328V6.36328H0V7.36328Z" fill="white"/>
                      </svg>

                      {/* <img src={data.caseStudy.buttonLabel} alt="" /> */}
                    </span>

                 </a>
                ) : (
                  <div className="financial-planning__case-study">
                    <div className="financial-planning__case-image-wrapper">
                        <img
                          src={data.caseStudy.image}
                          alt=""
                          className="financial-planning__case-image"
                        />

                        <span className="financial-planning__case-label">
                          {data.caseStudy.label}
                        </span>
                      </div>

                      <h3 className="financial-planning__case-title">
                        {data.caseStudy.title}
                      </h3>

                      <p className="financial-planning__case-description">
                        {data.caseStudy.description}
                      </p>

                      {/* <span className="financial-planning__case-button" dangerouslySetInnerHTML={{__html:data.caseStudy.buttonLabel}}> */}
                      <span className="financial-planning__case-button">
                        <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.7071 8.07039C18.0976 7.67986 18.0976 7.0467 17.7071 6.65617L11.3431 0.292213C10.9526 -0.0983109 10.3195 -0.0983109 9.92893 0.292213C9.53841 0.682738 9.53841 1.3159 9.92893 1.70643L15.5858 7.36328L9.92893 13.0201C9.53841 13.4107 9.53841 14.0438 9.92893 14.4343C10.3195 14.8249 10.9526 14.8249 11.3431 14.4343L17.7071 8.07039ZM0 7.36328V8.36328H17V7.36328V6.36328H0V7.36328Z" fill="white"/>
                        </svg>

                        {/* <img src={data.caseStudy.buttonLabel} alt="" /> */}
                      </span>

                  </div>
              )}

              {/* <div className="financial-planning__case-image-wrapper">
                <img
                  src={data.caseStudy.image}
                  alt=""
                  className="financial-planning__case-image"
                />

                <span className="financial-planning__case-label">
                  {data.caseStudy.label}
                </span>
              </div>

              <h3 className="financial-planning__case-title">
                {data.caseStudy.title}
              </h3>

              <p className="financial-planning__case-description">
                {data.caseStudy.description}
              </p>

              //* <span className="financial-planning__case-button" dangerouslySetInnerHTML={{__html:data.caseStudy.buttonLabel}}> 
              <span className="financial-planning__case-button">
                <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7071 8.07039C18.0976 7.67986 18.0976 7.0467 17.7071 6.65617L11.3431 0.292213C10.9526 -0.0983109 10.3195 -0.0983109 9.92893 0.292213C9.53841 0.682738 9.53841 1.3159 9.92893 1.70643L15.5858 7.36328L9.92893 13.0201C9.53841 13.4107 9.53841 14.0438 9.92893 14.4343C10.3195 14.8249 10.9526 14.8249 11.3431 14.4343L17.7071 8.07039ZM0 7.36328V8.36328H17V7.36328V6.36328H0V7.36328Z" fill="white"/>
                </svg>

                {/* <img src={data.caseStudy.buttonLabel} alt="" />
              </span> */}


            {/* </a> */}
          </div>

          
        </div>
      </div>
    </section>
  );
}

export default ServiceSection

